class RelatedProducts extends HTMLElement {
  connectedCallback() {
    const { productId, sectionId, baseUrl, limit } = this.dataset;

    fetch(`${baseUrl}?product_id=${productId}&section_id=${sectionId}&limit=${limit}&intent=related`)
      .then((res) => res.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const recs = html.querySelector("related-products");
        if (recs && recs.innerHTML.trim().length) {
          this.innerHTML = recs.innerHTML;
        }
      });
  }
}

customElements.define("related-products", RelatedProducts);
